<template>
  <div class="pa-1">
    <empty-state
      v-if="loading || !data || data.length === 0"
      :loading="loading"
      :title="loading ? $t('loading') : $t('no_data_available')"
      :subtitle="!loading ? $t('no_meals_found') : ''"
      icon="mdi-food"
    />

    <!-- Mobile View -->
    <template v-if="device.isMobile && data.length">
      <mobile-data-cards
        :headers="mobileHeaders"
        :items="customSearch(data, mobileHeaders, searchQuery)"
        :loading="loading"
        item-key="id"
        :fields-per-row="3"
        :show-row-number="false"
        :bold-fields="['quantity']"
      >
        <template v-slot:item.name="{ item }">
          {{ toLatin(item.name) }}
        </template>
      </mobile-data-cards>

      <!-- Total footer for mobile -->
      <v-card class="mt-3 ordera-box-shadow" outlined>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ $t("total").toUpperCase() }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <div class="text-h6 font-weight-bold primary--text">
              {{ totalQuantity }}
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-card>
    </template>

    <!-- Desktop View -->
    <v-data-table
      v-if="!device.isMobile && data.length"
      :headers="headers"
      :items="customSearch(data, headers, searchQuery)"
      class="striped-table ordera-box-shadow"
      :loading="loading"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.num="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:item.name="{ item }">
        {{ toLatin(item.name) }}
      </template>
      <template v-slot:body.append>
        <tr class="font-weight-bold grey lighten-3">
          <td></td>
          <td>{{ $t("total").toUpperCase() }}</td>
          <td class="text-center">{{ totalQuantity }}</td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";
import MobileDataCards from "@/components/global/MobileDataCards.vue";

export default {
  name: "MealsTable",
  components: {
    EmptyState,
    MobileDataCards,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("food"), value: "name", sortable: false },
        {
          text: this.$t("quantity"),
          value: "quantity",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("notes"),
          value: "prilog",
          sortable: false,
        },
      ];
    },
    mobileHeaders() {
      return [
        { text: this.$t("food"), value: "name", sortable: false, cols: 6 },
        {
          text: this.$t("quantity"),
          value: "quantity",
          sortable: false,
          align: "center",
          cols: 3,
        },
        {
          text: this.$t("notes"),
          value: "prilog",
          sortable: false,
          cols: 3,
        },
      ];
    },
    totalQuantity() {
      return this.data.reduce((sum, item) => sum + item.quantity, 0);
    },
  },
};
</script>
